import React, {ReactElement} from 'react';

import LayoutSection, {LayoutBackground} from '../../DesignSystem/Layout/LayoutSection/LayoutSection';
import Carousel from '../../DesignSystem/Carousel/Carousel';
import {PressItem} from './types';
import Paragraph from '../../DesignSystem/Text/Paragraph/Paragraph';
// import PressKitButton from '../../DesignSystem/Buttons/PressKit/PressKit';
import {Alignment} from '../../../types';

import './Press.scss';

interface Props {
  press: PressItem[];
}

function Press({press}: Props): ReactElement {
  return (
    <LayoutSection innerClassName="press" type={LayoutBackground.WHITE}>
      <Carousel>
        {press.map(({name, quote, image}) => (
          <div className="press__item" key={name}>
            <Paragraph italic alignment={Alignment.CENTER}>
              &quot;{quote.quote}&quot;
            </Paragraph>
            <div className="press__item__imageWrapper">
              <img src={image.file.url} alt={name} />
            </div>
          </div>
        ))}
      </Carousel>
      {/* @todo reinstate once presskit is complete, https://app.clubhouse.io/fundingoptions/story/18914/hide-the-download-our-press-kit-button-until-the-pack-has-been-updated
      <div className="press__kit">
        <PressKitButton />
      </div> */}
    </LayoutSection>
  );
}

export default Press;
